<template>
  <Fragment>
    <v-progress-linear
      indeterminate
      color="yellow darken-2"
      class="mt-5"
    ></v-progress-linear>
    <br>
    <v-progress-linear
      indeterminate
      color="green"
      class="mt-5"
    ></v-progress-linear>
    <br>
    <v-progress-linear
      indeterminate
      color="teal"
      class="mt-5"
    ></v-progress-linear>
    <br>
    <v-progress-linear
      indeterminate
      color="cyan"
      class="mt-5"
    ></v-progress-linear>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

export default {
  name: 'Loader',
  components: {
    Fragment
  }
}
</script>

<style>

</style>